// React
import React, { Component } from 'react';
// Styles
import '../styles.scss';

export class Button extends Component {
    render() {
        const {id, text, type, disabled, onClick, className, innerRef, ...props } = this.props;
        return (
            <button {...props} ref={innerRef} id={id} className={`platform_btn platform_btn__${type} ${className ? className : ''}`} disabled={disabled} onClick={onClick}>{text}</button>
        );
    }
}

